import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table, Loader} from 'semantic-ui-react';
import {filter} from 'lodash';
import './table.scss';

class DetailByDayList extends Component {
  render() {
    const {transactionType} = this.props;
    return (
      <Table striped className={`scrollable-body liquidations-by-day-detail-table ${transactionType}`}>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell textAlign='center'>PEDIDO</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>CHASSIS</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>KATASHIKI</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>DESCRIPCION</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>COLOR</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>RESERVADO</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
    
        <Table.Body>
          {this.renderLoaderOrDetail()}
        </Table.Body>
      </Table>
    );
  }

  renderLoaderOrDetail() {
    const {loading} = this.props;
    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderLiquidationsDetail();
  }

  renderLiquidationsDetail() {
    const {liquidationsDetail, transactionType} = this.props;
    const transactionSelected = transactionType && transactionType === 'liquidations' ? 'LIQUIDACION' : 'FACTURACION';
    const list = filter(liquidationsDetail, {'transaction': transactionSelected});

    if (!list.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={7}>No hay datos</Table.Cell>
        </Table.Row>
      );
    }

    return list.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.order}</Table.Cell>
          <Table.Cell textAlign='center'>{element.chassis}</Table.Cell>
          <Table.Cell textAlign='center'>{element.katashiki}</Table.Cell>
          <Table.Cell textAlign='center'>{element.description}</Table.Cell>
          <Table.Cell textAlign='center'>{element.color}</Table.Cell>
          <Table.Cell textAlign='center'>{element.reservedTo}</Table.Cell>
        </Table.Row>
      );
    });
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'loading': state.liquidationsByDays.loadingDetail,
    'liquidationsDetail': state.liquidationsByDays.listDetail,
  };
};

export default connect(mapStateToProps, {
})(DetailByDayList);
